import { translations, type Locale } from "./translations";
export type Catalog = Record<string, string>;
const loaders = import.meta.glob("./catalogs/**/*.json", { import: "default" }) as Record<string, () => Promise<Catalog>>;
const cache = new Map<Locale, Promise<Catalog>>();

function directTranslations(locale: Locale) {
  const catalog: Catalog = {};
  for (const namespace of Object.keys(translations.en) as Array<keyof typeof translations.en>) {
    const english = translations.en[namespace] as Record<string, string>;
    const localized = translations[locale][namespace] as Record<string, string>;
    for (const key of Object.keys(english)) catalog[english[key].replace(/\s+/g, " ").trim()] = localized[key] ?? english[key];
  }
  return catalog;
}

export function loadCatalog(locale: Locale) {
  const cached = cache.get(locale);
  if (cached) return cached;
  const pending = Promise.all(Object.entries(loaders).filter(([file]) => file.startsWith(`./catalogs/${locale}/`)).map(([, load]) => load()))
    .then(catalogs => Object.assign(directTranslations(locale), ...catalogs));
  cache.set(locale, pending);
  return pending;
}
